module.exports = __webpack_public_path__ + "static/media/ic-profile-avatar.0fd584eb.svg";